import React from "react";
import { DataRequestDetail } from "../../../../../common/models";
import { RemoveConsumer } from "./opt-out/RemoveConsumer";
import { NotifyThirdParties } from "./opt-out/NotifyThirdParties";

type Props = {
  request: DataRequestDetail;
};

export const RequestToOptOutSteps: React.FC<Props> = ({ request }) => {
  switch (request.state) {
    case "REMOVE_CONSUMER":
      return <RemoveConsumer />;
    case "CONTACT_VENDORS":
      return <NotifyThirdParties />;
  }
  return null;
};
